module.exports = __webpack_public_path__ + "static/img/ncw-pc-join.ce8d7678.jpg";